// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"19cd5b1c","342":"34116816","495":"6182fa82","712":"5b05e1ed"}[chunkId] + ".chunk.js";
};